"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _multipleValueField = _interopRequireDefault(require("./multiple-value-field"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var SelectField =
/*#__PURE__*/
function (_MultipleValueField) {
  (0, _inherits2.default)(SelectField, _MultipleValueField);

  function SelectField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'SelectField');
    return _this;
  }

  (0, _createClass2.default)(SelectField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'options',
            component: 'OptionsField',
            docLevel: 'basic'
          }, {
            name: 'blankString',
            component: 'TextField'
          }, {
            name: 'ensureInList',
            component: 'BooleanField'
          }, {
            name: 'multiple',
            component: 'BooleanField'
          }, {
            name: 'removeIfNotInList',
            component: 'BooleanField'
          }, {
            name: 'autocomplete',
            component: 'BooleanField'
          }]
        }
      });

      this._setDefaults(props, {
        ensureInList: true,
        multiple: false,
        removeIfNotInList: true,
        autocomplete: true
      });
    }
  }, {
    key: "_setProperty",
    value: function _setProperty(name, value) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "_setProperty", this).call(this, name, value); // Automatically set allowScalar

      if (name === 'multiple') {
        this.set({
          allowScalar: !value
        });
      }
    }
  }, {
    key: "getOne",
    value: function getOne(name) {
      // We consider the blank string to be a null value. We have to use isValueBlank() to prevent
      // infinite recursion.
      if (name === 'value' && this.isValueBlank(this._value)) {
        return null;
      }

      return (0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "getOne", this).call(this, name);
    } // TODO: use indexedOptions cache to speed up getOptionLabel, i.e. indexedOptions is calculated in
    // set() when options set and then used here.

  }, {
    key: "getOptionLabel",
    value: function getOptionLabel(value) {
      var label = null;

      if (this._options) {
        this._options.forEach(function (option) {
          if (option.value === value) {
            label = option.label;
          }
        });
      }

      return label;
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this2 = this;

      (0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "validate", this).call(this);

      if (!this.isBlank() && this.get('ensureInList')) {
        var value = this.get('value');
        var values = this.get('multiple') ? value : [value];
        var errors = [];
        values.forEach(function (val) {
          if (_this2.getOptionLabel(val) === null) {
            errors.push({
              error: "".concat(val, " is not an option")
            });
          }
        });

        if (errors.length > 0) {
          this.setErr(errors);
        }
      }
    }
  }, {
    key: "_setValue",
    value: function _setValue(value) {
      var _this3 = this;

      if (this.get('removeIfNotInList') && value) {
        // Clone so that we don't modify original data
        value = (0, _cloneDeep.default)(value);
        var values = this.get('multiple') ? value : [value];
        var newValues = [];
        values.forEach(function (val, i) {
          if (_this3.getOptionLabel(val) !== null) {
            // In the list
            newValues.push(val);
          }
        });
        (0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "_setValue", this).call(this, this.get('multiple') ? newValues : newValues[0]);
      } else {
        (0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "_setValue", this).call(this, value);
      }
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      var _this4 = this;

      var value = this.get('value');

      if (this.isBlank()) {
        return value;
      } else if (this.get('multiple')) {
        return value.map(function (val) {
          return _this4.getOptionLabel(val);
        });
      } else {
        return this.getOptionLabel(value);
      }
    }
  }, {
    key: "isValueBlank",
    value: function isValueBlank(value) {
      if ((0, _get2.default)((0, _getPrototypeOf3.default)(SelectField.prototype), "isValueBlank", this).call(this, value)) {
        return true;
      } else if (value === '') {
        // value can be '' for select when blankString selected
        return true;
      } else if (this.get('multiple')) {
        return Array.isArray(value) && value.length === 0;
      } else {
        return false;
      }
    }
  }]);
  return SelectField;
}(_multipleValueField.default);

exports.default = SelectField;